import { render } from "./CheckCircle.vue?vue&type=template&id=beaefda8"
import script from "./CheckCircle.vue?vue&type=script&lang=js"
export * from "./CheckCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CheckCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beaefda8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beaefda8', __exports__)) {
    api.reload('beaefda8', __exports__)
  }
  
  module.hot.accept("./CheckCircle.vue?vue&type=template&id=beaefda8", () => {
    api.rerender('beaefda8', render)
  })

}


export default __exports__